import React from "react";
import styles from "./Team.module.css";
const Team = ({ name, image, instagram, children }) => {
  return (
    <>
      <div className={styles.team}>
        <div className={styles.boximage}>
          <img alt={name} src={image} />
        </div>
        <h3 className={styles.boxname}>{name}</h3>
        <div className={styles.desc}>{children}</div>
        <div className={styles.instagram}>
          <a target="_blank" href={`https://instagram.com/${instagram}`}>
            <div className={styles.instagramlogo}>
              {instagram}
              <i className="fa-brands fa-instagram"></i>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default Team;
